import { render, staticRenderFns } from "./DatePickerInput.vue?vue&type=template&id=04b2e7fe&scoped=true"
import script from "./DatePickerInput.vue?vue&type=script&lang=js"
export * from "./DatePickerInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b2e7fe",
  null
  
)

export default component.exports